/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import "./style.scss";
import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Select, message, Input, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import API from "../../../api";
import urls from "../../../api/urls";

const { PRS_LIST, DELIVERY_PARTNER_LIST } = urls;

// Dummy data for testing
const dummyData = [
  {
    prsNumber: "PRS123456",
    sellerName: "Amazon Retail",
    sellerVendorCode: "AMZ001",
    sellerZip: "400001",
  },
  {
    prsNumber: "PRS123457",
    sellerName: "Flipkart India",
    sellerVendorCode: "FLP002",
    sellerZip: "110001",
  },
  {
    prsNumber: "PRS123458",
    sellerName: "Myntra Fashion",
    sellerVendorCode: "MYN003",
    sellerZip: "560001",
  },
  {
    prsNumber: "PRS123459",
    sellerName: "Ajio Fashion",
    sellerVendorCode: "AJI004",
    sellerZip: "380001",
  },
  {
    prsNumber: "PRS123460",
    sellerName: "Nykaa Beauty",
    sellerVendorCode: "NYK005",
    sellerZip: "400001",
  },
];

const PendingPrsList = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deliveryPartners, setDeliveryPartners] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPrs, setSelectedPrs] = useState(null);
  const [selectedDeliveryPartner, setSelectedDeliveryPartner] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // For testing, using dummy data
    setTableData(dummyData);
    fetchDeliveryPartners();
  }, []);

  const fetchDeliveryPartners = async () => {
    try {
      const result = await API.Api(DELIVERY_PARTNER_LIST).get();
      const response = result?.response?.data;
      if (response?.status === 200) {
        setDeliveryPartners(response.data);
      }
    } catch (error) {
      message.error("Failed to fetch delivery partners");
    }
  };

  const handleAssignDP = (record) => {
    setSelectedPrs(record);
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setSelectedPrs(null);
    setSelectedDeliveryPartner(null);
  };

  const handleAssign = async () => {
    if (!selectedDeliveryPartner) {
      message.error("Please select a delivery partner");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        prsNumber: selectedPrs.prsNumber,
        dpId: selectedDeliveryPartner
      };
      const result = await API.Api(urls.PRS_ASSIGN_DA).post(payload);
      if (result?.response?.data?.status === 200) {
        message.success("Delivery partner assigned successfully");
        handleModalCancel();
        // For testing, remove the assigned PRS from the table
        setTableData(prevData => prevData.filter(item => item.prsNumber !== selectedPrs.prsNumber));
      }
    } catch (error) {
      message.error("Failed to assign delivery partner");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    if (!value) {
      setTableData(dummyData);
      return;
    }
    const filteredData = dummyData.filter(
      (item) =>
        item.prsNumber.toLowerCase().includes(value.toLowerCase()) ||
        item.sellerName.toLowerCase().includes(value.toLowerCase()) ||
        item.sellerZip.includes(value)
    );
    setTableData(filteredData);
  };

  const columns = [
    {
      title: "PRS Number",
      dataIndex: "prsNumber",
      key: "prsNumber",
    },
    {
      title: "Seller Name",
      dataIndex: "sellerName",
      key: "sellerName",
    },
    {
      title: "Seller Vendor Code",
      dataIndex: "sellerVendorCode",
      key: "sellerVendorCode",
    },
    {
      title: "Seller Zip",
      dataIndex: "sellerZip",
      key: "sellerZip",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleAssignDP(record)}>
          Assign DP
        </Button>
      ),
    },
  ];

  return (
    <div className="master-main-container m-1 mt-3 p-1">
      <div className="row">
        <b className="master-title">Pending PRS Mapping</b>
      </div>
      <div className="mb-3">
        <Input
          placeholder="Search by PRS Number, Seller Name or Zip"
          prefix={<SearchOutlined />}
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 400 }}
          allowClear
        />
      </div>
      <Table
        columns={columns}
        dataSource={tableData}
        loading={loading}
        rowKey="prsNumber"
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
        }}
      />
      <Modal
        title="Assign Delivery Partner"
        open={isModalOpen}
        onCancel={handleModalCancel}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>
            Cancel
          </Button>,
          <Button
            key="assign"
            type="primary"
            onClick={handleAssign}
            loading={loading}
          >
            Assign
          </Button>,
        ]}
      >
        <Select
          style={{ width: "100%" }}
          placeholder="Select Delivery Partner"
          onChange={(value) => setSelectedDeliveryPartner(value)}
          options={deliveryPartners.map((dp) => ({
            value: dp.dpId,
            label: dp.dpName,
          }))}
        />
      </Modal>
    </div>
  );
};

export default PendingPrsList;
